function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#Router_svg__clip0)"
}, React.createElement("path", {
  d: "M21.02 8.1c6.604-6.131 17.354-6.134 23.956-.004l.003.003a1.5 1.5 0 002.042-2.198l-.004-.003c-7.754-7.2-20.284-7.196-28.038.003a1.5 1.5 0 002.042 2.198z"
}), React.createElement("path", {
  d: "M38.921 14.042c-3.275-3.39-8.567-3.39-11.842 0a1.5 1.5 0 01-2.158-2.084c4.455-4.61 11.703-4.61 16.158 0a1.5 1.5 0 01-2.158 2.084zM26.25 36.75a2.25 2.25 0 114.5 0 2.25 2.25 0 01-4.5 0zm8.75 0a2.25 2.25 0 114.5 0 2.25 2.25 0 01-4.5 0z"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M34.5 18a1.5 1.5 0 00-3 0v10.502H8.25a8.25 8.25 0 00-1.5 16.364v1.636a1.5 1.5 0 003 0v-1.5h28.5v1.5a1.5 1.5 0 003 0v-1.636a8.25 8.25 0 00-1.5-16.364H34.5V18zM8.25 31.502H18v10.5H8.25a5.25 5.25 0 110-10.5zm31.5 0H21v10.5h18.75a5.25 5.25 0 100-10.5z"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "Router_svg__clip0"
}, React.createElement("path", {
  d: "M0 0h48v48H0V0z"
})));

function SvgRouter(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    width: "1em",
    height: "1em"
  }, props), _ref, _ref2);
}

export default SvgRouter;